module.exports = __webpack_public_path__ + "img/illustrations3.0063d125.png";